/** @format */

import { ArrowRightIcon } from '@heroicons/react/solid';
import React from 'react';
import resume from '../../images/Resume.pdf';

export default function Navbar() {
  return (
    <header className="top-0 z-10 bg-gray-800 md:sticky">
      <div className="container flex flex-col flex-wrap items-center p-5 mx-auto md:flex-row">
        <div className="mb-4 font-medium text-white title-font md:mb-0">
          <a href="#about" className="ml-3 text-xl">
            Mohamed Daadaa
          </a>
        </div>
        <nav className="flex flex-wrap items-center justify-center text-base md:mr-auto md:ml-4 md:py-1 md:pl-4 md:border-l md:border-gray-700">
          <a href="#projects" className="mr-5 hover:text-white">
            Past Work
          </a>
          <a href="#skills" className="mr-5 hover:text-white">
            Skills
          </a>
          <a href="#blogs" className="mr-5 hover:text-white">
            Blog
          </a>
        </nav>
        {/* <a
              className="inline-flex items-center px-3 py-1 ml-3 text-base text-white bg-green-500 rounded focus:outline-none hover:bg-gray-700 md:mt-0"
              href={resume}
              attributes-list
              download="Resume"
            >
              {' '}
              My Resume
            </a> */}
        <a
          href="#contact"
          className="inline-flex items-center px-3 py-1 mt-4 ml-3 text-base bg-gray-800 border-0 rounded focus:outline-none hover:bg-gray-700 md:mt-0"
        >
          Hire Me
          <ArrowRightIcon className="w-4 h-4 ml-1" />
        </a>
      </div>
    </header>
  );
}
